<span [ngClass]="dynamicClasses">{{ title }}</span>
